export default __webpack_public_path__ + "static/media/necromancer_icon.a6e8002f.png";